import React from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { PrivateRoute } from 'lib/core/components'
import { CustomerDashboard } from 'scenes/CustomerDashboard'
import { Impersonate } from 'scenes/CustomerDashboard/scenes/Impersonate'

export const Customer = () => {
  return (
    <Switch>
      <Route
        exact
        path='/customer/account/impersonate/:token'
        component={Impersonate}
      />

      <PrivateRoute
        path='/customer/account'
        component={CustomerDashboard}
      />

      <Redirect
        to='/customer/account'
      />
    </Switch>
  )
}
